module.exports = __webpack_public_path__ + "static/img/15.d7f8619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/15.jpg
// module id = 9Lax
// module chunks = 16